import { GlobalAxios } from "../axios/axios-config";
import {
  IAutomationRulesMarCom,
  INewAutomationRulesMarCom,
} from "../models/automation-rule-marcom";
const AUTOMATION_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationRule";

export const createMarComAutomationRule = (
  params: INewAutomationRulesMarCom
) => {
  return GlobalAxios.post(AUTOMATION_RULE_ROUTE, params);
};

export const getMarComAutomationRuleId = (id: string) => {
  return GlobalAxios.get<IAutomationRulesMarCom>(
    AUTOMATION_RULE_ROUTE + "/" + id
  );
};

export const updateMarComAutomationRule = ({
  id,
  item,
}: {
  id: string;
  item: INewAutomationRulesMarCom;
}) => {
  return GlobalAxios.put(AUTOMATION_RULE_ROUTE + "/" + id, item);
};
